import React from 'react';
import { useNavigate } from 'react-router-dom';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import {
  StyledGatingDialog,
  GatingModalTitle,
  GatingModalContent,
  GatingLeadText,
  GatingModalActions,
  PrimaryGatingButton,
} from '../GatingDialog.styled';

/**
 * Blocks the app for business users until the partnership agreement is signed.
 * Shown when `business.PartnershipAgreementAcceptedAt` is not set.
 */
function PartnershipAgreementRequiredModal({ open }) {
  const navigate = useNavigate();

  return (
    <StyledGatingDialog
      open={open}
      disableEscapeKeyDown
      onClose={(_event, reason) => {
        if (reason === 'backdropClick') return;
      }}
    >
      <GatingModalTitle>
        <span className="gating-modal-icon-wrap" aria-hidden>
          <HandshakeRoundedIcon className="gating-modal-icon" />
        </span>
        Sign the partnership agreement
      </GatingModalTitle>

      <GatingModalContent>
        <GatingLeadText>
          Before you can manage your business on NKY Connect, you need to review
          and sign the partnership agreement.
        </GatingLeadText>
      </GatingModalContent>

      <GatingModalActions>
        <PrimaryGatingButton
          variant="contained"
          onClick={() => navigate('/provider-signup')}
        >
          Review and sign
        </PrimaryGatingButton>
      </GatingModalActions>
    </StyledGatingDialog>
  );
}

export default PartnershipAgreementRequiredModal;
